import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    info: {
      buildName: "",
      buildNamespace: "",
      buildSource: "",
      buildReference: "",
      buildCommit: "",
      versionMajor: "0",
      versionMinor: "0",
      versionBuild: "0",
    }
  },
  actions,
  getters,
  mutations,
}
